export default __webpack_public_path__ + "static/media/Pot3.4ca288ab.svg";